import './bootstrap';


//after 5 seconds divs with role="alert" will be removed
setTimeout(function() {
    $("div[role='alert']").hide('fast');
}, 3500);